import React from 'react'
import { Badge } from '@/components/ui/badge'

export function BlogStatusBadge({ published, archived }) {
  if (archived) {
    return (
      <Badge variant="secondary" className="bg-gray-200 text-gray-600 hover:bg-gray-200">
        Archived
      </Badge>
    )
  }

  return (
    <Badge
      variant={published ? 'success' : 'secondary'}
      className={published ? 'bg-green-100 text-green-700 hover:bg-green-100' : ''}
    >
      {published ? 'Published' : 'Draft'}
    </Badge>
  )
}
